import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_catalogo, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import { JsonImpuestoNomina } from '../../../Helpers/JsonToOneLevel';
import ModalService from '../../../ModalService/ModalService';
import AlertForm from '../../../../../../Services/AlertForm';
import FormularioImpuestoNomina from './FormularioImpuestoNomina';

const ModalAddImpuestoNomina = ({ openAdd, setOpenAdd, agregar, errorTable, informacionAdicional, nombreModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarImpuestoNomina = ( impuestoNomina ) => {
        axios.post( `${servicios_grupogack_catalogo}/isn/`, impuestoNomina, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        agregar( JsonImpuestoNomina(respuesta.data.dataResponse) );
                        setOpenAdd( false );
                        break;
                    case 400:
                    case 404:
                    case 302:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        //errorTable( respuesta.data.msg );
                        break;
                    default:
                        errorTable( registro_no_guardado );
                        break;
                }
            })
            .catch( error => {
                errorTable( registro_no_guardado );
            })
    }

    return (
        <ModalService title="Nuevo Impuesto Sobre Nómina" parentNode={nombreModulo} minWidth="40%"
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
                <FormularioImpuestoNomina
                    error={error}
                    informacion={informacionAdicional}
                    enviarImpuestoNomina={enviarImpuestoNomina}
                />
        </ModalService>
    );
};

export default ModalAddImpuestoNomina;